export enum AchievementCriteriaType {
   TotalPushedCodeAccumulated,
   TotalTestedCodeAccumulated,
   TotalProdCodeAccumulated,
   TotalBugsCodeAccumulated,
   TotalFundsAccumulated,
   ConcurrentCustomers,
   UnlockedBusinessUnits,
}



// WEBPACK FOOTER //
// ./src/app/models/achievements/achievement-criteria-type.enum.ts